import axios from 'axios';

import {
  addSection,
  updateSection,
  updateSections,
  removeSection,
  addFile,
  setFile,
  setFiles,
  removeFile,
} from '../../actions/dataRoomActions';

import {
  addQuickAccessFile,
  setQuickAccessFile,
  removeQuickAccessFile,
  removeDataRoom,
} from '../../actions/company/dataRoomActions';

const createSection = (dataRoomId, params) =>
  async (dispatch, getState) => {
    const companyId = getState().company.id;
    const res = await axios.post(`/company/${companyId}/data_rooms/${dataRoomId}/data_room_sections`, params);
    dispatch(addSection(res.data));
  };

const renameSection = (dataRoomId, id, params) =>
  async (dispatch, getState) => {
    const companyId = getState().company.id;
    const res = await axios.patch(`/company/${companyId}/data_rooms/${dataRoomId}/data_room_sections/${id}`, params);
    dispatch(updateSection(res.data));
  };

const deleteSection = (dataRoomId, id) =>
  async (dispatch, getState) => {
    const companyId = getState().company.id;
    const res = await axios.delete(`/company/${companyId}/data_rooms/${dataRoomId}/data_room_sections/${id}`);
    dispatch(removeSection(res.data));
  };

const updateSectionPosition = (dataRoomId, id, params) =>
  async (dispatch, getState) => {
    const companyId = getState().company.id;
    const res = await axios.patch(`/company/${companyId}/data_rooms/${dataRoomId}/data_room_sections/${id}/update_position`, params);
    dispatch(updateSections(res.data));
  };

const createFile = (dataRoomId, params) =>
  async (dispatch, getState) => {
    const companyId = getState().company.id;
    const res = await axios.post(`/company/${companyId}/data_rooms/${dataRoomId}/data_room_files`, params);
    dispatch(addFile(res.data));
  };

const moveFile = (dataRoomId, id, params) =>
  async (dispatch, getState) => {
    const companyId = getState().company.id;
    const res = await axios.patch(`/company/${companyId}/data_rooms/${dataRoomId}/data_room_files/${id}`, params);
    dispatch(removeFile(res.data));
    dispatch(addFile(res.data));
  };

const updateFile = (dataRoomId, id, params) =>
  async (dispatch, getState) => {
    const companyId = getState().company.id;
    const res = await axios.patch(`/company/${companyId}/data_rooms/${dataRoomId}/data_room_files/${id}`, params);
    dispatch(setFile(res.data));
  };

const updateFilePosition = (dataRoomId, id, params) =>
  async (dispatch, getState) => {
    const companyId = getState().company.id;
    const res = await axios.patch(`/company/${companyId}/data_rooms/${dataRoomId}/data_room_files/${id}/update_position`, params);
    dispatch(setFiles(res.data));
  };

const deleteFile = (dataRoomId, id) =>
  async (dispatch, getState) => {
    const companyId = getState().company.id;
    const res = await axios.delete(`/company/${companyId}/data_rooms/${dataRoomId}/data_room_files/${id}`);
    dispatch(removeFile(res.data));
  };

const createQuickAccessFile = (dataRoomId, params) =>
  async (dispatch, getState) => {
    const companyId = getState().company.id;
    const res = await axios.post(`/company/${companyId}/data_rooms/${dataRoomId}/data_room_files`, params);
    dispatch(addQuickAccessFile(res.data));
  };

const updateQuickAccessFile = (dataRoomId, id, params) =>
  async (dispatch, getState) => {
    const companyId = getState().company.id;
    const res = await axios.patch(`/company/${companyId}/data_rooms/${dataRoomId}/data_room_files/${id}`, params);
    dispatch(setQuickAccessFile(res.data));
  };

const deleteQuickAccessFile = (dataRoomId, id) =>
  async (dispatch, getState) => {
    const companyId = getState().company.id;
    const res = await axios.delete(`/company/${companyId}/data_rooms/${dataRoomId}/data_room_files/${id}`);
    dispatch(removeQuickAccessFile(res.data));
  };

const deleteDataRoom = (dataRoomId) =>
  async (dispatch, getState) => {
    const companyId = getState().company.id;
    const res = await axios.delete(`/company/${companyId}/data_rooms/${dataRoomId}`);
    dispatch(removeDataRoom(res.data));
  };

export {
  createSection,
  renameSection,
  deleteSection,
  updateSectionPosition,
  createFile,
  moveFile,
  updateFile,
  updateFilePosition,
  deleteFile,
  createQuickAccessFile,
  updateQuickAccessFile,
  deleteQuickAccessFile,
  deleteDataRoom,
};
